// SetPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SetPassword = () => {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  // ✅ Password strength check
  const isStrongPassword = (password) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  
    return (
      password.length >= minLength &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSpecialChar
    );
  };
  

  const handleSetPassword = async () => {
    if (newPassword !== confirmPassword) {
      return setMessage('❌ Passwords do not match');
    }

    if (!isStrongPassword(newPassword)) {
      return setMessage('❌ Password must be at least 8 characters long, contain an uppercase letter, lowercase letter, number and a special character.');
    }

    try {
      const res = await fetch('/api/set-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, newPassword })
      });

      const data = await res.json();

      if (!res.ok) {
        return setMessage(`❌ ${data.message || 'Failed to set password'}`);
      }

      setMessage('✅ Password set successfully! Redirecting...');
      window.location.href = '/';
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMessage('❌ Unexpected error');
    }
  };

  return (
    <div>
      <h2>Set Your Password</h2>
      <p>This page is for first-time users.</p>
      <p>Password must be at least 8 characters long, contain an uppercase letter, lowercase letter, number and a special character.</p>
      <div
  style={{
    marginTop: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    flexWrap: 'wrap'
  }}
>
  <input
    placeholder="Email"
    value={email}
    onChange={e => setEmail(e.target.value)}
    style={{
      padding: '12px',
      fontSize: '1.4rem',
      borderRadius: '6px',
      border: '1px solid #ccc',
      width: '250px'
    }}
  />
  <input
    type="password"
    placeholder="New Password"
    value={newPassword}
    onChange={e => setNewPassword(e.target.value)}
    style={{
      padding: '12px',
      fontSize: '1.4rem',
      borderRadius: '6px',
      border: '1px solid #ccc',
      width: '250px'
    }}
  />
  <input
    type="password"
    placeholder="Confirm Password"
    value={confirmPassword}
    onChange={e => setConfirmPassword(e.target.value)}
    style={{
      padding: '12px',
      fontSize: '1.4rem',
      borderRadius: '6px',
      border: '1px solid #ccc',
      width: '250px'
    }}
  />
  <button
    onClick={handleSetPassword}
    style={{
      padding: '12px 24px',
      fontSize: '1.2rem',
      backgroundColor: '#cab069',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      color: '#222',
      whiteSpace: 'nowrap'
    }}
  >
    Submit
  </button>
  {message && (
    <p style={{ color: message.includes('success') ? 'green' : 'red', fontSize: '1rem', width: '100%', textAlign: 'center' }}>
      {message}
    </p>
  )}
</div>

    </div>
  );
};

export default SetPassword;
